import { render } from "./BACAdditionalDocView.vue?vue&type=template&id=2975ea5c"
import script from "./BACAdditionalDocView.vue?vue&type=script&lang=js"
export * from "./BACAdditionalDocView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__